import { AEMErrorMessage } from '../../../models';

export const QuickLinksErrorMessage: AEMErrorMessage = {
  action: {
    label: '',
    url: '',
    id: ''
  },
  component: 'quick-links',
  errorId: [
    {
      errorCode: ''
    }
  ],
  featureTitle: 'Skymiles Quick Links',
  errorMessageDescription:
    'Sorry, we’re currently unable to display Quick Links. Please try again later.',
  errorMessageTitle: '',
  type: 'single-error'
};
